module.exports = __webpack_public_path__ + "static/crystal_intro_video.fb5f5ee6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crystal/crystal_intro_video.mp4
// module id = 73
// module chunks = 35783957827783 222309558401364 241894665707670